/* eslint-disable require-jsdoc */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as dates from '@simplybenefits/sb-dates';
import Table from '@mui/material/Table/Table';
import TableHead from '@mui/material/TableHead/TableHead';
import TableRow from '@mui/material/TableRow/TableRow';
import TableCell from '@mui/material/TableCell/TableCell';
import TableBody from '@mui/material/TableBody/TableBody';
import { Theme, Button, Text, i18n, tokens } from "@simplybenefits/sb-ui-library";
import { getPendingChangeData } from '../../../actions/admin';
import { useTheme } from '@mui/material/styles';

const PendingChangesTable = ({ records, removeChange, dispatch }) => {
    const [ state, setState ] = useState({
        selectedChangeID: null,
        changes: null
    });

    const _selectChange = async (changeID) => {
        if (state.selectedChangeID === changeID) {
            setState({
                selectedChangeID: null,
                changes: null
            });

            return;
        }

        const changes = await dispatch(getPendingChangeData(changeID));

        setState({
            selectedChangeID: changeID,
            changes
        });
    };

    const theme = useTheme();
    const styles = {
        scrollbar: {
            '&::webkitScrollbar': {
                height: '15px',
                width: '15px'
            },
            '&::webkitScrollbarThumb': {
                backgroundColor: Theme.colors.surface,
                borderRadius: '10px',
                boxShadow: 'inset 0 0 2px rgba(0, 0, 0, .5)'
            },
            '&::webkitScrollbarTrack': {
                backgroundColor: Theme.colors.backgroundGrey,
                borderRadius: '10px',
                boxShadow: 'inset 0 0 2px rgba(0, 0, 0, 0.2)'
            }
        },
        tableHeading: {
            paddingTop: "10px",
            paddingBottom: "10px",
            paddingRight: "2vw",
            paddingLeft: "2vw",
            fontFamily: Theme.fonts.type.heading,
            color: Theme.colors.surface,
            whiteSpace: "nowrap",
            borderBottom: "none"
        },
        tableCell: {
            paddingTop: "10px",
            paddingBottom: "10px",
            fontFamily: Theme.fonts.type.light,
            whiteSpace: "nowrap",
            paddingRight: "2vw",
            paddingLeft: "2vw",
            color: Theme.colors.mainTextGrey
        }
    };
    return (
        <div style={{ overflow: "auto", maxHeight: 600, ...styles.scrollbar }}>
            <Table>
                <TableHead>
                    <TableRow sx={{ backgroundColor: theme.palette.primary.main }}>
                        <TableCell sx={styles.tableHeading}>
                            { i18n.t(tokens.labels.type) }
                        </TableCell>

                        <TableCell sx={styles.tableHeading}>
                            { i18n.t(tokens.labels.admin.label) }
                        </TableCell>

                        <TableCell sx={styles.tableHeading}>
                            { i18n.t(tokens.labels.admin.profileCertificate) }
                        </TableCell>

                        <TableCell sx={styles.tableHeading}>
                            { i18n.t(tokens.labels.admin.changedBy) }
                        </TableCell>

                        <TableCell sx={styles.tableHeading}>
                            { i18n.t(tokens.labels.admin.processed) }
                        </TableCell>

                        <TableCell sx={styles.tableHeading}>
                            { i18n.t(tokens.labels.effectiveDate) }
                        </TableCell>

                        <TableCell sx={styles.tableHeading} />
                    </TableRow>
                </TableHead>

                <TableBody>
                    {
                        records.map((item, index) => {
                            let backgroundObject = { border: "none" };
                            if (index % 2 !== 0) {
                                backgroundObject = { backgroundColor: Theme.colors.backgroundGrey, border: "none" };
                            }

                            return (
                                <React.Fragment key={item.changeID}>
                                    <TableRow>
                                        <TableCell sx={{ ...styles.tableCell, ...backgroundObject }}>
                                            { item.type }
                                        </TableCell>

                                        <TableCell sx={{ ...styles.tableCell, ...backgroundObject }}>
                                            { item.label }
                                        </TableCell>

                                        <TableCell sx={{ ...styles.tableCell, ...backgroundObject }}>
                                            { item.profile }
                                        </TableCell>

                                        <TableCell sx={{ ...styles.tableCell, ...backgroundObject }}>
                                            { item.changedBy }
                                        </TableCell>

                                        <TableCell sx={{ ...styles.tableCell, ...backgroundObject }}>
                                            { dates.getLocalDisplay(item.occurred, 'lll', i18n.locale) }
                                        </TableCell>

                                        <TableCell sx={{ ...styles.tableCell, ...backgroundObject }}>
                                            { dates.getStartOfDay(item.effectiveDate, 'll', i18n.locale) }
                                        </TableCell>

                                        <TableCell sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', ...styles.tableCell, ...backgroundObject }}>
                                            {
                                                [ i18n.t(tokens.labels.employees.memberUpdate), i18n.t(tokens.labels.employees.dependentUpdate), i18n.t(tokens.labels.employees.beneficiaryUpdate), i18n.t(tokens.labels.employees.massSalaryUploaded) ].indexOf(item.type) !== -1 &&
                                                    <Button transparent onClick={ () => _selectChange(item.changeID) }>
                                                        { i18n.t(tokens.buttons.details)}
                                                    </Button>
                                            }

                                            <Button transparent onClick={ () => removeChange(item.changeID) }>
                                                { i18n.t(tokens.buttons.remove) }
                                            </Button>
                                        </TableCell>
                                    </TableRow>

                                    {
                                        state.selectedChangeID === item.changeID &&
                                    <TableRow>
                                        <TableCell sx={{ ...styles.tableCell, ...backgroundObject }} colSpan={6}>
                                            {
                                                state.changes.map((change, changeIndex) => (
                                                    <Text key={changeIndex} small bold margin="5px 0">{ change }</Text>
                                                ))
                                            }
                                        </TableCell>
                                    </TableRow>
                                    }
                                </React.Fragment>
                            );
                        })
                    }
                </TableBody>
            </Table>
        </div>
    );
};

PendingChangesTable.propTypes = {
    records: PropTypes.array
};

export default (connect()(PendingChangesTable));